// plugins/floating-vue.client.js
import { defineNuxtPlugin } from '#app'
import FloatingVue, { VTooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'
import { normalizeTooltipValue } from '~/utils/tooltipBinding'

function withNormalizedTooltipValue(binding) {
    const value = normalizeTooltipValue(binding.value);

    if (value === binding.value) {
        return binding;
    }

    return {
        ...binding,
        value,
    };
}

const normalizedTooltipDirective = {
    beforeMount(el, binding) {
        VTooltip.beforeMount(el, withNormalizedTooltipValue(binding));
    },
    updated(el, binding) {
        VTooltip.updated(el, withNormalizedTooltipValue(binding));
    },
    beforeUnmount(el) {
        VTooltip.beforeUnmount(el);
    },
};

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(FloatingVue, {
        themes: {
            tooltip: {
                popperTriggers: ['hover'],
                delay: {
                    show: 200,
                    hide: 150,
                },
            },
        },
    })

    // FloatingVue's install() has already registered v-tooltip, so swap the
    // registration in place. Calling app.directive() again would warn that the
    // directive has already been registered.
    nuxtApp.vueApp._context.directives.tooltip = normalizedTooltipDirective;
})